import React, { useState, useEffect } from 'react'
import { Box, Card, CardContent, CardHeader, Grid, Button, Stack, FormControl, InputLabel, Select, MenuItem, Alert, Typography } from '@mui/material'
import SaveIcon from '@mui/icons-material/Save'; import SearchIcon from '@mui/icons-material/Search'
import AssignmentIcon from '@mui/icons-material/Assignment'
import { useSnackbar } from 'notistack'
import authService from '../services/authService'
import normaService from '../services/normaService'; import crudsService from '../services/crudsService'
import PageHeader from '../components/common/PageHeader'

export default function OficinaTipoNormaLegal() {
  const { enqueueSnackbar } = useSnackbar()
  const [oficinas, setOficinas] = useState([]); const [tiposNormas, setTiposNormas] = useState([]); const [tiposAsignados, setTiposAsignados] = useState([])
  const [selectedOficina, setSelectedOficina] = useState(''); const [selectedTipos, setSelectedTipos] = useState([]); const [loading, setLoading] = useState(false)

  useEffect(() => {
    const area = authService.getUserDataArea()[0]
    normaService.getOficinas(null, area).then(res => setOficinas(res.data?.data || [])).catch(() => {})
    normaService.getTiposNormas().then(res => setTiposNormas(res.data?.data || [])).catch(() => {})
  }, [])

  const handleOficinaChange = (idOficina) => {
    setSelectedOficina(idOficina)
    setSelectedTipos([])
    setLoading(true)
    normaService.getTiposNormasPorOficina(idOficina)
      .then(res => setTiposAsignados((res.data?.data || []).map(t => t.id_tipo_nl)))
      .catch(() => {}).finally(() => setLoading(false))
  }

  const handleTiposChange = (e) => {
    setSelectedTipos(e.target.value)
  }

  const handleGuardar = async () => {
    if (!selectedOficina) { enqueueSnackbar('Seleccione una Oficina', { variant: 'warning' }); return }
    setLoading(true)
    try {
      const tiposObjs = selectedTipos.map(id => tiposNormas.find(t => t.id === id)).filter(Boolean)
      await crudsService.oficinaTipoNormaLegal({ id: selectedOficina }, tiposObjs)
      enqueueSnackbar('Tipos de Norma asignados correctamente', { variant: 'success' })
      handleOficinaChange(selectedOficina)
    } catch { enqueueSnackbar('Error al guardar', { variant: 'error' }) }
    finally { setLoading(false) }
  }

  return (
    <Box>
      <PageHeader title="Oficina × Tipo de Norma Legal" subtitle="Asignar tipos de normas a oficinas" icon={AssignmentIcon} />
      <Grid container spacing={3}>
        <Grid item xs={12} md={8} sx={{ mx: 'auto' }}>
          <Card>
            <CardContent>
              <Stack spacing={3}>
                <FormControl fullWidth size="small">
                  <InputLabel>Seleccionar Oficina *</InputLabel>
                  <Select value={selectedOficina} label="Seleccionar Oficina *" onChange={e => handleOficinaChange(e.target.value)}>
                    {oficinas.map(o => <MenuItem key={o.id} value={o.id}>{o.descripcion}</MenuItem>)}
                  </Select>
                </FormControl>

                {selectedOficina && (
                  <>
                    <Alert severity="info">
                      <Typography variant="body2">Seleccione los tipos de normas legales que puede publicar esta oficina</Typography>
                    </Alert>

                    <FormControl fullWidth size="small">
                      <InputLabel>Tipos de Norma Legal</InputLabel>
                      <Select
                        multiple
                        value={selectedTipos}
                        label="Tipos de Norma Legal"
                        onChange={handleTiposChange}
                        disabled={loading}
                      >
                        {tiposNormas.map(t => (
                          <MenuItem key={t.id} value={t.id}>
                            {t.descripcion}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>

                    <Stack direction="row" spacing={2} justifyContent="center">
                      <Button variant="contained" startIcon={<SaveIcon />} onClick={handleGuardar} disabled={loading}>
                        Guardar Asignación
                      </Button>
                    </Stack>
                  </>
                )}
              </Stack>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  )
}
